import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/images/loginimg.png'
import _imports_1 from '../assets/images/loginlog.png'


const _hoisted_1 = { id: "loginContainer" }
const _hoisted_2 = { class: "postion" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "loginimg",
  alt: "",
  srcset: ""
}, null, -1 /* HOISTED */)
const _hoisted_4 = {
  key: 0,
  class: "loginBox",
  style: {"width":"320px","height":"400px"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  width: "148",
  alt: "",
  srcset: ""
}, null, -1 /* HOISTED */)
const _hoisted_6 = {
  key: 1,
  class: "loginBox",
  style: {"width":"320px","height":"400px"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  width: "148",
  alt: "",
  srcset: ""
}, null, -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "VersionFont" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Version 2025.0218.01")
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.showLogin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_el_form, {
              ref: "formLogin",
              rules: _ctx.rules,
              model: _ctx.loginForm,
              style: {"margin-top":"35px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { prop: "username" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "请输入账号",
                      maxlength: "20",
                      "prefix-icon": "User",
                      modelValue: _ctx.loginForm.username,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginForm.username) = $event)),
                      modelModifiers: { trim: true },
                      onKeyup: _withKeys(_ctx.login, ["enter"])
                    }, null, 8 /* PROPS */, ["modelValue", "onKeyup"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_el_form_item, { prop: "password" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "password",
                      placeholder: "请输入密码",
                      modelValue: _ctx.loginForm.password,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginForm.password) = $event)),
                      modelModifiers: { trim: true },
                      onKeyup: _withKeys(_ctx.login, ["enter"]),
                      maxlength: "15",
                      minlength: "6",
                      "prefix-icon": "lock"
                    }, null, 8 /* PROPS */, ["modelValue", "onKeyup"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  style: {"width":"100%","margin-top":"68px"},
                  onClick: _ctx.login
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("登录")
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["rules", "model"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_el_form, {
              ref: "formPass",
              rules: _ctx.passRules,
              model: _ctx.updateForm,
              labelPosition: "top",
              "hide-required-asterisk": "",
              style: {"margin-top":"35px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "新密码：",
                  prop: "newPassword"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "password",
                      "prefix-icon": "lock",
                      placeholder: "6-15位，同时包含字母和数字",
                      "show-password": "",
                      modelValue: _ctx.updateForm.newPassword,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.updateForm.newPassword) = $event)),
                      modelModifiers: { trim: true },
                      onKeyup: _withKeys(_ctx.setPassword, ["enter"]),
                      maxlength: "15",
                      minlength: "6"
                    }, null, 8 /* PROPS */, ["modelValue", "onKeyup"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_el_form_item, {
                  label: "确认密码：",
                  prop: "checkPassword"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "password",
                      "prefix-icon": "lock",
                      placeholder: "请再次输入新密码",
                      "show-password": "",
                      modelValue: _ctx.updateForm.checkPassword,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.updateForm.checkPassword) = $event)),
                      modelModifiers: { trim: true },
                      onKeyup: _withKeys(_ctx.setPassword, ["enter"]),
                      maxlength: "15",
                      minlength: "6"
                    }, null, 8 /* PROPS */, ["modelValue", "onKeyup"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  style: {"width":"100%"},
                  onClick: _ctx.setPassword
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("确认")
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["rules", "model"])
          ]))
    ]),
    _hoisted_8
  ]))
}